<script lang="ts">
    export let icon1: string,
        icon2: string,
        title1: string,
        title2: string,
        selected = 0
</script>

<div class="buttonRow label">
    <button
        class:selected="{selected == 0}"
        on:click|preventDefault|stopPropagation="{() => {
            selected = 0
        }}"
    >
        <div class="icon">
            <img
                src="../../../assets/icons/{icon1}"
                alt="icon"
            />
        </div>
        <p class="label-content">{title1}</p>
    </button>
    <button
        class:selected="{selected == 1}"
        on:click|preventDefault|stopPropagation="{() => {
            selected = 1
        }}"
    >
        <div class="icon">
            <img
                src="../../../assets/icons/{icon2}"
                alt="icon"
            />
        </div>
        <p class="label-content">{title2}</p>
    </button>
</div>

<style lang="less">
    .buttonRow {
        display: flex;
        border-radius: 0.6rem;
        border: 1px solid var(--grey-200);
        background: var(--white-100);
        width: fit-content;
        button {
            padding: 0.6rem;
            width: 50px;
            color: var(--white-100);
            p {
                display: none;
            }
            &.selected {
                border-radius: 10px;
                background: var(--text-100);
                width: 200px;
                display: flex;
                align-items: center;
                p {
                    padding: 0px 0.6rem;
                    font-weight: bold;
                    display: flex;
                    color: var(--white-100);
                }
            }
        }
    }
</style>
